import type { SaveGame } from "./types";


export function cloneSave(save: SaveGame): SaveGame {
  return cloneValue(save);
}

export function cloneValue<T>(value: T): T {
  return JSON.parse(JSON.stringify(value)) as T;
}

export function addIsoDays(dateIso: string, days: number): string {
  const date = new Date(`${dateIso}T00:00:00Z`);
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
}

export function addIsoMinutes(dateIso: string, minutes: number): string {
  const date = new Date(dateIso);
  date.setUTCMinutes(date.getUTCMinutes() + minutes);
  return date.toISOString();
}

export function addIsoDateTimeDays(dateIso: string, days: number): string {
  const date = new Date(dateIso);
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString();
}

export function nextId(prefix: string, value: number) {
  return `${prefix}-${String(value).padStart(4, "0")}`;
}

export function clamp(value: number, min: number, max: number) {
  const cappedValue = Math.min(max, value);
  return Math.max(min, cappedValue);
}

export function signed(value: number) {
  const rounded = Number(value.toFixed(1));
  if (value >= 0) {
    return `+${rounded}`;
  }
  return rounded.toString();
}

export function formatSignedMoney(value: number) {
  const sign = moneySign(value);
  return `${sign}$${Math.abs(Math.round(value)).toLocaleString("en-US")}`;
}

function moneySign(value: number): string {
  if (value >= 0) {
    return "+";
  }
  return "-";
}

export function deterministicHash(value: string): number {
  let hash = 0;
  for (let index = 0; index < value.length; index += 1) {
    hash = (hash * 31 + value.charCodeAt(index)) >>> 0;
  }
  return hash;
}
